module.exports = __webpack_public_path__ + "static/media/new-share1.a3dff688.png";